module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Extralight.93eacb6d.eot";